var Backbone = require('backbone'),
    fvChannel = require('glRadio').channel('FV');

module.exports = Backbone.Model.extend({
    defaults: {
        editMode: false,
        expanded: false,
        navigationEnabled: null, //( can click on link) -- start empty
        viewerPgNumber: 0, // */ this really for new page text notes, updates on change)
        isEditable: true, // (hide/show mod btns)
        replyMode: false, /* note: now only for flash note */
        currentConsultColorForShapes: null, // the derived color to apply from the currently selected consult groups ( TODO: should change the the selected groups and derive the color )
        isUserDrawingShape: false, // only for drawable notes but not subclassing for simplicity
        isFiltered: false
    },
    initialize: function(options) {
        this.parent = options.parent; //(the actual note model)
        this.set('currentConsultColorForShapes', this.parent.getConsultColorForShapes() );
    },
    setEditMode: function(val, options) {   //true or false
        this.set({ editMode: val }, options);
    },
    toggleEditMode: function() {
        this.set({ editMode: !this.get('editMode') });
    },
    setNavigationEnabled: function(enable) {  //force change in the model
        this.set('navigationEnabled', null, {silent: true});
        this.set('navigationEnabled', enable);
    },
    getCurrentConsultColorForShapes: function() {
        return this.get('currentConsultColorForShapes');
    },
    resetOnCancelChanges: function(originalConsultColorForShapes) {

        this.set('currentConsultColorForShapes', originalConsultColorForShapes, {silent: true});

    },

    setIsFiltered: function( isFiltered ) {
        this.set( 'isFiltered', isFiltered );
    },

    isFiltered: function() {
        return this.get('isFiltered');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/noteUI.js
 ** module id = 154
 ** module chunks = 0
 **/